var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "heatmap-container", attrs: { id: "heatmapSection" } },
    [
      _c(
        "b-tabs",
        {
          attrs: { "content-class": "mt-2" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("b-tab", { attrs: { title: "Gene set × genes by phenotype" } }, [
            _c("div", {
              staticClass: "heatmap-tab-content",
              attrs: { id: "heatmapTabGenes" },
            }),
          ]),
          _c("b-tab", { attrs: { title: "Phenotype × gene set" } }, [
            _c("div", {
              staticClass: "heatmap-tab-content",
              attrs: { id: "heatmapTabPhenotypeGeneSet" },
            }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }